module.exports = __webpack_public_path__ + "media/images/setting/icon3-166fa826ed15e38d7a2ef195ed8c032e.svg";